import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Nav, NavItem, NavLink
} from "reactstrap";
import Thumbnails from "../../PageProductDetails/Detail/Thumbnails"
import classNames from 'classnames';
import FontAwesome from "react-fontawesome";
import { getCloudImageUrl, normalizeBrand, emptyImage } from "../../../utils/Helpers";
import { getCollectionList, getImageBanner } from '../../../actions/kafairAction';
import { TextRupiah } from "../../../components/Text";

import { doFetchProducts, getTrendingProduct } from "../../../actions/productAction";

import accessories from "../../../images/APRILWEEK2-NEWSIZE-04.png";
import emptySneakerImg from '../../../images/emptysneakers2.png';
import emptyApparelImg from '../../../images/emptyapparels.png';
import emptyHandbagImg from '../../../images/emptyhandbags.png';

const previewSettings = {
  arrows: true,
  // autoplay:true,
  infinite: true,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 5,
  lazyLoad: true,
  dots: false,
  swipe: false,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
}

class Accessories extends Component {
  constructor(props: Object) {
    super(props);
    this.state = {
      activeTab: 1,
      category: "handbags",
      page: 1,
      per_page: 20,
    }
    this.tabs = [
      {
        heading: "Sneakers Box"
      },
      {
        heading: "Shoelace"
      },
      {
        heading: "Spray"
      },
      {
        heading: "Browse All"
      }
    ];
  }

  componentDidMount() {
    const payload = {
      params: {
        category: "handbags",
        per_page: 20,
        page: 1
      }
    }
    this.props.getTrendingProduct(payload, "handbags")
  }

  renderHeaderTab = () => {
    const { activeTab } = this.state

    return (
      <Nav tabs>
        {
          this.tabs.map((item: Object, index: number) =>
            <NavItem key={index}>
              <NavLink
                className={classNames({ active: activeTab === index + 1 })}
              // onClick={() => this.toggle(index + 1, item.category)}
              >
                {item.heading}
              </NavLink>
            </NavItem>
          )
        }
      </Nav>
    )
  }

  renderTabPage = () => {
    const { category } = this.state
    const { dataTrending } = this.props

    return (
      <div>
        {
          dataTrending.length > 0 ?
            <Thumbnails
              settings={previewSettings}
              afterChange={this.changeImage}
              beforeChange={this._handleBeforeChange}
              thumbnails={dataTrending.map(item => {
                return {
                  id: item.id,
                  slug: item.slug,
                  img: item.product_variant_images.length ? getCloudImageUrl(item.product_variant_images[0].URL, 400) : emptyImage(category),
                  display_name: item.display_name,
                  brand: item.product && item.product.brand && item.product.brand.flat[0],
                  price: item.price,
                  out_of_stock: item.out_of_stock,
                  category
                }
              })}
              active={this.state.currentIndex}
              renderItems={dataTrending => this._renderItems(category, dataTrending)}
            />
            : null
        }
      </div>
    )
  }

  _renderItems(category: string, data: Array<Object>) {
    return data.map((item, index) => (
      <a
        href={`/${category}/${item.id}/${item.slug}`}
        title={item.display_name}
        key={index}
        className="sneaker-item"
      >
        <div className={classNames("product-card", { "disabled": !item.price || item.out_of_stock })}>

          <KickImage
            alt={item.display_name}
            src={item.img}
            className={classNames("sneaker-item__image", { "disabled": !item.price || item.out_of_stock })}
          />
          <div className={classNames("sneaker-item__text", { "disabled": !item.price || item.out_of_stock })}>
            <p>{item.brand ? normalizeBrand(item.brand) : null}</p>
            <p>{item.display_name}</p>
          </div>
          {
            item.price ?
              <TextRupiah
                value={item.price}
                className="price-tag"
                color="black"
                bold={true}
                align="center"
              />
              :
              <span className="text-center red">Out of stock</span>
          }
        </div>
      </a>
    )
    );
  }


  render() {
    return (
      <div className="accessories-section">
        <KickImage
          src={accessories}
        />
        {this.renderHeaderTab()}
        {this.renderTabPage()}
      </div>
    )
  }
}

interface Data {
  data: Array<Object>;
}
interface dataProduct {
  products: Data;
  isFetch: boolean;
  trending: Data
}
interface State {
  dataProduct: dataProduct
}

const mapStateToProps = (state: State) => ({
  dataProducts: state.dataProduct.products.data,
  isFetching: state.dataProduct.isFetch,
  dataTrending: state.dataProduct.trending.data
})

const mapDispatchToProps = (dispatch: any) => ({
  getProducts: () => dispatch(doFetchProducts()),
  getTrendingProduct: (payload: Object, category: string) => dispatch(getTrendingProduct(payload, category))
})
export default connect(mapStateToProps, mapDispatchToProps)(Accessories)
